// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionBtn_root__R3X6F","disabled":"ActionBtn_disabled__ze75J"};